/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2019-05-31 14:47:27
 * @LastEditors: yy
 * @LastEditTime: 2020-10-14 16:46:52
 */
import baseChart from './customBaseChart'

const parseList = (list, row) => {
  const result = {}
  list && list.forEach((item, index) => {
    Object.keys(row || item).forEach(ele => {
      if (!result[ele]) {
        result[ele] = Array(list.length).fill(0)
      }
      result[ele][index] = (item[ele] || 0)
    })
  });
  
  return result
};


export default (opt = {}) => {

  let { list, colorList, colors } = opt;
  

  if (!colorList) {
    colorList = []
  }

  const result = parseList(list);

  let axis = {
    xAxis: {
      type: 'value'
    },
    yAxis: {
      type: 'category',
      data: result.name
    }
  }

  if (opt.axis !== 'horizontal') {
    axis = {
      xAxis: {
        type: 'category',
        data: result.name
      },
      yAxis: {
        type: 'value'
      }
    }
  }

  return Object.assign(baseChart(opt), {
    ...axis,
    clear: true,
    legend: {
      top: 50,
      data: colorList.map(item => item.name)
    },
    series: colorList.map((item, index) => ({
      name: item.name,
      barGap: 0,
      data: result[item.value],
      type: 'bar',
      stack: 'one',
      itemStyle: {
        normal: {
          color: item.color || ''
        }
      }
    }))
  })
}


// WEBPACK FOOTER //
// src/chart/fiveFavor.js